import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Catalogs: one JSON per namespace, merged into the default namespace. Keys are English source messages (en-US is generated).
const load = (ctx) => Object.assign({}, ...ctx.keys().map((k) => ctx(k)));
const resources = {
  "en-US": { translation: load(require.context("./locales/en-US", false, /\.json$/)) },
  "fr-FR": { translation: load(require.context("./locales/fr-FR", false, /\.json$/)) },
};

export const SUPPORTED = { "fr-FR": "Français", "en-US": "English" };
const LEGACY = { fr: "fr-FR", en: "en-US" };

export function detectLocale() {
  const saved = localStorage.getItem("tt_locale") || LEGACY[localStorage.getItem("tt_lang")];
  if (SUPPORTED[saved]) return saved;
  const nav = (navigator.languages && navigator.languages[0]) || navigator.language || "";
  return /^fr/i.test(nav) ? "fr-FR" : "en-US";
}

i18n.use(initReactI18next).init({
  resources, lng: detectLocale(), fallbackLng: "en-US", supportedLngs: Object.keys(SUPPORTED),
  keySeparator: false, nsSeparator: false, returnEmptyString: false,
  interpolation: { escapeValue: false }, react: { useSuspense: false },
});
const syncDocument = () => {
  document.documentElement.lang = i18n.language.slice(0, 2);
  document.title = i18n.t("TOPTALENT.IO — Find the talent others can't.");
};
syncDocument();
i18n.on("languageChanged", syncDocument);

export const hasExplicitLocale = () => !!(localStorage.getItem("tt_locale") || localStorage.getItem("tt_lang"));

export function setLocale(locale) {
  if (!SUPPORTED[locale]) return;
  localStorage.setItem("tt_locale", locale);
  localStorage.removeItem("tt_lang");
  document.documentElement.lang = locale.slice(0, 2);
  return i18n.changeLanguage(locale);
}

export function applyAccountLocale(locale) {
  if (SUPPORTED[locale] && !hasExplicitLocale() && locale !== i18n.language) i18n.changeLanguage(locale);
}

export const t = (...a) => i18n.t(...a);
// Marks a module-level string as a translation key (extracted by scripts/i18n.js); translate at render with t().
export const tk = (s) => s;
export default i18n;
